import React from 'react';
import ProgressBar from '../../progressBar/progressBar';
import CheckInDate from './checkInDate';
import CheckOutDate from './checkOutDate';
import CheckOutInfo from './checkOutInfo';

const CardServiceState = (props) => {
  const {data: { dateStart, old_date, time, time_end, old_time, schedule, dateEnd, state, dateStartState, dateEndState, checkoutInfo, isAppointment, is_cancelled, is_history, missedAppointment, is_confirmed, full_day }, isSmall, styleClass} = props;
  const { bars } = state;
  const isFullDay = full_day === true;
  const displayedStartDate = dateStartState || dateStart;
  const displayedEndDate = dateEndState || dateEnd;
  // When full day, the end date is only presented if it's different from the start date
  const isEndDateSameAsStart = isFullDay && !!dateEnd && !!displayedEndDate && displayedEndDate === displayedStartDate;
  const showCheckoutDate = !(!dateEnd && isAppointment) && !isEndDateSameAsStart;
  // When only the start date is presented, it's centered in the card
  const isCheckinDateOnly = isFullDay && !showCheckoutDate;
  
  const renderCheckinDate = () => {
    return <CheckInDate data={{bars, dateStart, old_date, time, old_time, schedule, dateStartState, isSmall, isAppointment, hasDateEnd: !!dateEnd, full_day, isSingleDate: isCheckinDateOnly}}/>
  }

  const renderCheckoutDate = () => {
    if (!showCheckoutDate) return;
    return <CheckOutDate data={{bars, dateEnd, dateEndState, time_end, full_day}}/>;
  }
  const renderDates = () => {
    return (
      <div className='service-equipment-data mt-2 align-items-start'>
        {renderCheckinDate()}
        {renderCheckoutDate()}
      </div>
    );
  }

  const renderCheckoutInfo = () => {
    if (!checkoutInfo) {
      return <></>;
    }
    return (
      <div className='service-equipment-data my-1 justify-content-end'>
        <CheckOutInfo data={{ checkoutInfo }}/>
      </div>
    );
  }


  return (
    <div className={`card-service-state-container ${styleClass || ''}`}>
      <div className='card-service-info-container'>
        { renderDates() }
        { renderCheckoutInfo() }
        <ProgressBar small={isSmall} levels="5" state={state} is_cancelled={is_cancelled} is_confirmed={is_confirmed} isAppointment={isAppointment} missedAppointment={missedAppointment} is_history={is_history} />
      </div>
    </div>
  );
}

export default CardServiceState;